import React, { useEffect, useRef } from "react";

const TURNSTILE_SITE_KEY = "0x4AAAAAAFhvmPE3_l-wUpVj";
const TURNSTILE_SCRIPT_URL = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

const TurnstileWidget = ({ onToken }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    let widgetId = null;
    const renderWidget = () => {
      widgetId = window.turnstile.render(containerRef.current, {
        sitekey: TURNSTILE_SITE_KEY,
        callback: onToken,
      });
    };

    let script = document.getElementById("turnstile-script");
    if (!script) {
      script = document.createElement("script");
      script.id = "turnstile-script";
      script.src = TURNSTILE_SCRIPT_URL;
      document.head.appendChild(script);
    }

    if (window.turnstile) {
      renderWidget();
    } else {
      script.addEventListener("load", renderWidget);
    }

    return () => {
      script.removeEventListener("load", renderWidget);
      if (widgetId) {
        window.turnstile.remove(widgetId);
      }
    };
  }, [onToken]);

  return <div ref={containerRef} className="mb-3"></div>;
};

export default TurnstileWidget;
